import { render, staticRenderFns } from "./LanguageBar.vue?vue&type=template&id=180b78b0&scoped=true&"
import script from "./LanguageBar.vue?vue&type=script&lang=js&"
export * from "./LanguageBar.vue?vue&type=script&lang=js&"
import style0 from "./LanguageBar.vue?vue&type=style&index=0&id=180b78b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b78b0",
  null
  
)

export default component.exports